export enum SvcClients {
  AdminSvc = 0,
  ResourceSvc = 1,
  DwollaSvc = 2,
 // CrmProxyApi = 2
}
